@use 'sass:math';
@use 'src/global/variables.scss' as var;

$alert-width: 350px;
$alert-height: 175px;
$alert-padding: 30px;
$margin: 8px;

:host {
  display: block;
}
  @media print {
    .noPrint {
      display:none !important;
    }
  }

:host(.open-animation) {
  visibility: visible;
  #cb-alert {
    z-index: 1001;
    bottom: var.$bot-position;
    right: var.$bot-position;
    animation: grow 240ms forwards ease-in-out;

    #cb-alert-text {
      animation: fade-in 240ms forwards ease-in-out 0.5s;
    }

    #cb-alert-text > p {
      margin: 0;
    }

    #cb-alert-buttons {
      animation: fade-in 240ms forwards ease-in-out 0.5s;
    }
  }
  .avatar-container {
    z-index: 1001;
    bottom: var.$bot-position;
    right: var.$bot-position;
    animation: avatar-up 240ms forwards ease-in-out;
    c-avatar-bot {
      animation: avatar-grow 240ms forwards ease-in-out;
    }
    c-avatar-button {
      animation: avatar-grow 240ms forwards ease-in-out;
    }
  }
}

:host(.close-animation) {
  #cb-alert {
    animation: shrink 240ms backwards ease-in-out 0.5s;

    #cb-alert-text {
      animation: fade-out 240ms backwards ease-in-out;
    }

    #cb-alert-buttons {
      animation: fade-out 240ms backwards ease-in-out;
    }
  }
  .avatar-container {
    animation: avatar-down 240ms backwards ease-in-out 0.5s;
    c-avatar-bot {
      animation: avatar-shrink 240ms backwards ease-in-out 0.5s;
    }
    c-avatar-button {
      animation: avatar-shrink 240ms backwards ease-in-out 0.5s;
    }
  }
}

.avatar-container {
  width: var.$avatar-alert-size;
  height: var.$avatar-alert-size;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: -(var.$avatar-alert-size);
  right: -(var.$avatar-alert-size);
  z-index: 1;
  c-avatar-button {
    width: var.$avatar-button-diameter;
    height: var.$avatar-button-diameter;
  }
}

#cb-alert {
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  height: var.$avatar-alert-size;
  width: var.$avatar-alert-size;
  border-radius: math.div(var.$avatar-alert-size, 2);
  position: fixed;
  bottom: -(var.$avatar-alert-size);
  right: -(var.$avatar-alert-size);
  border: 1px solid black;
  padding: 0;
  background-color: var.$primary-color;
  color: white;

  #cb-alert-text {
    opacity: 0;
    word-break: break-word;
    hyphens: manual;
  }

  #cb-alert-buttons {
    opacity: 0;
    margin-top: 16px;
    display: flex;

    button:first-child {
      margin-right: $margin;
    }
    button {
      width: 50%;
      font-size: 1em;
      background: var.$primary-color;
      border: 1px solid currentColor;
      color: var.$text-color-light;
      cursor: pointer;
      padding: 5px 0;

      &:hover,
      &:focus {
        outline: none;
        border-color: var.$focus-color;
        box-shadow: 0 0 0 1px var.$focus-color;
      }
    }
  }
}

@keyframes fade-in {
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes grow {
  to {
    padding: $alert-padding #{var.$avatar-alert-size + 2 * $margin} $alert-padding $alert-padding;
    width: $alert-width;
    height: $alert-height;
  }
}
@media (max-width: 500px) {
  @keyframes grow {
    to {
      padding: $alert-padding #{var.$avatar-alert-size + 2 * $margin} $alert-padding $alert-padding;
      width: calc(100% - (2 * #{var.$bot-position}));
      height: $alert-height;
    }
  }
}
@keyframes shrink {
  from {
    padding: $alert-padding #{var.$avatar-alert-size + 2 * $margin} $alert-padding $alert-padding;
    width: $alert-width;
    height: $alert-height;
  }
  to {
    padding: 0;
    width: var.$avatar-alert-size;
    height: var.$avatar-alert-size;
  }
}
@media (max-width: 500px) {
  @keyframes shrink {
    from {
      padding: $alert-padding #{var.$avatar-alert-size + 2 * $margin} $alert-padding $alert-padding;
      width: calc(100% - (2 * #{var.$bot-position}));
      height: $alert-height;
    }
    to {
      padding: 0;
      width: var.$avatar-alert-size;
      height: var.$avatar-alert-size;
    }
  }
}

@keyframes avatar-up {
  to {
    right: #{var.$bot-position + $margin};
    bottom: #{math.div($alert-height, 2) + var.$bot-position - math.div(var.$avatar-alert-size, 2)};
  }
}
@keyframes avatar-down {
  from {
    right: #{var.$bot-position + $margin};
    bottom: #{math.div($alert-height, 2) + var.$bot-position - math.div(var.$avatar-alert-size, 2)};
  }
  to {
    right: var.$bot-position;
    bottom: var.$bot-position;
  }
}
@keyframes avatar-grow {
  to {
    width: var.$avatar-alert-size;
    height: var.$avatar-alert-size;
  }
}
@keyframes avatar-shrink {
  from {
    width: var.$avatar-alert-size;
    height: var.$avatar-alert-size;
  }
  to {
    width: var.$avatar-button-diameter;
    height: var.$avatar-button-diameter;
  }
}
